<template lang='pug'>
  v-container.pa-0(fill-height='', fluid='')
    //- dialogs
    v-dialog(transition="dialog-bottom-transition" :max-width='!isMobile ? "750px" : "100%"' v-model='dialogOrder' fullscreen v-if="dialogOrder")
      order-modal(:shop="shopSelected" @closeModalOrder="dialogOrder=false")
    v-dialog(transition="dialog-bottom-transition" :max-width='!isMobile ? "600px" : "100%"' v-model='dialogUserLocation' :fullscreen="isMobile" v-if="dialogUserLocation && $store.state.users.profile")
      user-locations(:currentPosition="txtAddress" @closeModalUserLocation="dialogUserLocation=false")
    v-dialog(v-model='descriptionDialog' max-width="500" persistent)
      v-card(style="border: 1px solid;")
        v-card-title
          | Detalle del producto
          v-spacer
            v-icon(aria-label="Close" @click="descriptionDialog = false")
              | mdi-close
        v-card-text.body-1.text-center
          v-card(flat v-if='currentProduct.data && currentProduct.data.pictures.imageInput1 !== ""' column xs12).mt-4.text-xs-center.product--detail__product--img__img
            img( :src="currentProduct.data.pictures.imageInput1"  style="max-height: 200px; object-fit:contain;")
          v-layout(v-else="" column xs12)
            p.text-center sin imagen
            v-card.pa-1.mx-auto.mt-0.d-inline-flex.v-card--account(class='grey--text' outlined="" height="150" width="150")
              v-icon.mx-auto(size="96")
                | mdi-close
          p Nombre: {{currentProduct.data && currentProduct.data.name ? currentProduct.data.name : 'no hay nombre' }}
          p Descripción:
          p {{currentProduct.data && currentProduct.data.description ? currentProduct.data.description  : 'Este producto no cuenta con una descripcion por el momento' }}
          p.text-center.red--text( v-if='currentProduct && getStock(currentProduct.data) == "0" && currentProduct.data.type !== "service"').d-none Este producto esta agotado
          v-btn(color="primary" style="padding: 10px !important" v-if="!isInCart" :disabled="currentProduct && getStock(currentProduct.data) == '0' && currentProduct.data.type !== 'service'" @click="addToCart(currentProduct)").d-none Agregar a la canasta
          v-row.justify-center(v-if="isInCart").d-none
            //- creo que aqui no debe ser currentProduct ya que este viene del inventario y no de el carrito
            v-btn(icon='' color='primary' @click="quitAmount(cartIndex,producIndex,cartId, currentProduct)")
              v-icon mdi-minus
            p(v-if="!currentProduct.data.magnitude" style="padding: 2px; padding-top: 10px; margin-bottom: 0px;") {{currentProduct.amount}}
            v-text-field(v-else v-model="currentProduct.data.newAmount" style="max-width: 50px;margin: 0;padding: 0;" :rules="[rules.number, rules.minValue]" @change="updateAmount(cartIndex,producIndex,cartId, currentProduct)")
            v-btn(icon='' color='primary'  @click="addAmount(cartIndex,producIndex,cartId, currentProduct)")
              v-icon mdi-plus
    //- Content
    v-layout.ma-0.marketplace-container
      //- Filters
      v-layout(:class="switch1 ? 'filter-container':''" :absolute="isMobile").my-0.search-filter.xs12.md3.pa-4.ml-0
        v-row
          //- Search List
          v-layout().search-filter__search
            v-toolbar(dense="" v-if="switch1 && !isMobile")
              gmap-autocomplete(@place_changed="setPlace" :value="address" :options="autocompleteOptions" placeholder="Introduce tu dirección").location-input
              v-btn(v-if="address" icon="" color="primary" @click="clearAutomplete")
                v-icon mdi-close
              v-btn(icon="" @click="filterDialog = !filterDialog")
                v-icon mdi-dots-vertical
            //- Direction
            v-layout.mb-1(v-if="isMobile")
              v-flex.d-flex.align-center.justify-center()
                v-icon(color="#049d9f") mdi-map-marker
                span.ml-2.search__location(v-if="txtAddress" @click="dialogUserLocation = true" style="cursor: pointer") {{txtAddress}}
                span.ml-2.search__location(v-else @click="dialogUserLocation = true" style="cursor: pointer") No podemos acceder a tu ubicación
                v-btn(small text  @click="switch1 = !switch1")
                  v-icon(size="32") {{switch1 ? 'mdi-view-list' : 'mdi-earth'}}
                v-btn(small text color="black" dark="" @click="filterDialog = true")
                  v-icon(size="32") mdi-filter
            //- Dailog search mobile
            v-row.hidden-md-and-up.search-filter__search__item
              //- Button
              .autocomplete-block(style='min-width: 250px;' v-if="switch1")
                gmap-autocomplete(@place_changed="setPlace" :value="address" :options="autocompleteOptions" placeholder="Introduce tu dirección").location-input
                v-btn(v-if="address" icon="" color="primary" @click="clearAutomplete")
                  v-icon mdi-close
              .autocomplete-block(style='min-width: 250px;' v-if="!switch1")
                input(v-model="searchCategoryInShop" placeholder="Busca por categorias de los productos" type="text").input-product.location-input
                v-btn(v-if="searchCategoryInShop" icon="" color="primary" @click="searchCategoryInShop=''")
                  v-icon mdi-close
                //-v-text-field(v-model="searchCategoryInShop" flat solo label="Busca por producto")
              v-btn(small color="#049d9f" @click="search()").ml-2 Buscar
              v-dialog(v-if="filterDialog && isMobile" v-model="filterDialog" fullscreen="" style='overflow: hidden;'  transition="dialog-bottom-transition")
                //- Filter dialog
                v-card.filter-block(style="overflow-x: hidden")
                  v-card-title.pa-0
                    v-toolbar.custom-toolbar-wrapper(dark="" height="75px" color="primary")
                      .brand-icon(@click="filterDialog = false")
                        v-icon(size="20" color="white") mdi-close
                      .toolbar-header.mx-auto
                        p FILTRO
                  //- Filter content
                  .filter-block__content.container
                    v-row
                      v-col(cols="12" md="12").justify-center
                        //- header
                        .filter-block__header-wrapper
                          h3.filter-block__header.text-uppercase.text-center.color-secondary Personaliza tu busqueda
                        v-card.overflow-hidden.mt-0(flat)
                          v-row(no-gutters="")
                            v-col(cols="12" md="4")
                              v-card.my-0
                                v-card-text
                                  v-row
                                    // v-col(cols="12" md="6")
                                      v-switch(v-model='switch1' :label='`Ver en: ${switch1 === true ? "LISTA" : "MAPA"}`')
                                    v-col(cols="12" md="12")
                                      v-select(:items='mainCategories', item-text='data' return-object label='Categoria' v-model="mainCategorieSelect")
                                    v-col(cols="12" md="12")
                                      v-text-field(style="padding: 0px; margin: 0px;" v-model="searchTable" append-icon="mdi-magnify" label="Busca por nombre" single-line="" hide-details="")
                                    v-col(cols="12" md="12" style="padding-left: 30px; padding-bottom: 30px;")
                                      h4() Distancia (KM)
                                    v-col(cols="12" md="12" style="padding-left: 30px;")
                                      v-subheader.pl-0
                                        v-slider(v-model="rangeShop" thumb-label="always" :max="10")
                  v-row
                    v-col(cols="12" md="12").text-center
                      v-btn(color="primary" @click="seachByFilter") Filtrar
            //- Filter desktop
            v-card.filter-sidebar(flat v-if="filterDialog && !isMobile" style="overflow-x:hidden").mt-1.pa-2
              //- Direction
              v-layout.mb-1(v-if="filterDialog").mt-1
                v-flex.d-flex.align-center.justify-center(@click="dialogUserLocation = true" style="cursor: pointer")
                  img(src="@/assets/images/location-icon.png")
                  span.ml-2.video-card__location(v-if="txtAddress") {{txtAddress}}
                  span.ml-2.video-card__location(v-else) No podemos acceder a tu ubicación
              v-row.ma-2
                v-col(cols="12" md="12").justify-center
                  //- header
                  .filter-block__header-wrapper
                    h3.filter-block__header.text-uppercase.text-center.color-secondary Personaliza tu busqueda
                  v-row
                    // v-col(cols="12" md="6")
                      v-switch(v-model='switch1' :label='`Ver en: ${switch1 === true ? "LISTA" : "MAPA"}`')
                    // v-col(cols="12" md="12")
                      gmap-autocomplete(@place_changed="setPlace" :options="autocompleteOptions" placeholder="Introduce una dirección").location-input
                    v-col(cols="12" md="12")
                      v-select(:items='mainCategories', item-text='data' return-object label='Categorias' v-model="mainCategorieSelect" @change="search()")
                    v-col(cols="12" md="12")
                      v-text-field(style="padding: 0px; margin: 0px;"  @click:append="search" @keyup.enter="search" v-model="searchTable" append-icon="mdi-magnify" label="Busca por nombre" single-line="" hide-details="")
                    v-col(cols="12" md="12" style="padding-left: 30px; padding-bottom: 30px;")
                      h4() Distancia (KM)
                    v-col(cols="12" md="12" style="padding-left: 30px;")
                      v-subheader.pl-0
                        v-slider(v-model="rangeShop" thumb-label="always" :max="10" @change="search()")
                    v-col(cols="12" md="12").text-center
                      v-btn(color="primary" @click="clearFilter" small :disable="!mainCategorieSelect || !searchTable") Vaciar buscador
      v-layout.marketplace__map.xs12.md9.ma-0
        // Mapa
        v-layout( style="min-height: 100vh; min-width: 100%" v-if="switch1")
          v-progress-linear(v-if="searching" indeterminate="" color="secondary").loading-bar
          gmap-map( :center="center" :zoom="zoom" style="width:100%;  height: 100%;" :options="option")
            gmap-marker(:icon='getMarkerOptions(m.data.img)' :key="index" v-for="(m, index) in markers" :animation="3" :position="m.position" :clickable="true" @click="openInfoWindow(m)" rounded)
            gmap-info-window(:options="infoOptions" :position="infoContent.position" :opened="infoWinOpen" @closeclick="infoWinOpen=false" style="padding: 0px; ")
              v-card.ma-0(flat :loading="loading" max-width="374" style="overflow: hidden;").map-card
                v-img(height="100" :src="(infoContent.data.img == undefined || infoContent.data.img == '') ? imgShopDefault : infoContent.data.img.imageInput1").map-card__image
                div(style="position:relative").d-flex.justify-space-between.align-center
                  .display-1
                    .map-card__title {{infoContent.data.name}}
                  v-btn(style='right: 0;' absolute top right fab small color="info" @click="selectShop(infoContent)").ma-0
                    v-icon(small='') mdi-cart
                div.ml-auto
                  .map-card__content
                    span {{infoContent.data.description}}
                    br
                    v-row
                      v-col
                        p.my-1 Domicilio:
                        b(v-if="infoContent.data.domicileValue")  $ {{infoContent.data.domicileValue}}
                      v-col
                        p.my-1 Compra mínima:
                        b(v-if="infoContent.data.minOrderValue")  $ {{infoContent.data.minOrderValue}}
                    v-divider.my-2
                    div
                      v-icon(small='') mdi-map-marker
                      | {{infoContent.data.address}} | {{infoContent.data.addressgoogle}}
        // Lista
        v-col(cols="12" v-if="!switch1").search
          v-progress-linear(v-if="searching" indeterminate="" color="secondary")
          v-row.search__shops
            v-col(v-for="(m, index) in markers").search__shop
              v-avatar( @click="selectShop(m)").search__avatar
                v-img(v-if='m.data.img.imageInput1' :src="m.data.img.imageInput1" class="map-card" alt="store").search__rounded-img
                v-img(v-else src="https://via.placeholder.com/150" class="map-card" alt="store")
              |{{m.data.name}}
          v-divider
          v-container(v-if="markers.length !== 0")
            v-row(v-for="(m, index) in markers").my-6
              v-col(cols="12")
                v-avatar( @click="selectShop(m)").search__avatar
                  v-img(v-if='m.data.img.imageInput1' :src="m.data.img.imageInput1" class="map-card" alt="store").search__rounded-img
                  v-img(v-else src="https://via.placeholder.com/150" class="map-card" alt="store")
                span.search__shop-title {{m.data.name}}
              v-row(v-if="m.data.topSales").search__topsale
                v-col(v-for="(item, index) in m.data.topSales.slice(0,6)" cols="4").search__topsales-item
                  img(@click="showDescription(item, m.data)" :src="item.pictures.imageInput1 === '' ? allCategorys : item.pictures.imageInput1").search__topsales-item-img
                  span.search__topsales-item-title {{item.name}}
                  b.search__topsale-item-price {{item.price.sale | numberFormat}}
                  v-btn(small color="#a0c49a" @click="addToCart(item, m)" v-if="item.location[m.data.id].stock > 0").d-block Agregar
                  p.text-center.red--text( v-else class="text-caption") Agotado
                v-row(v-if="m.data.loadingTopProds" cols="12" style="overflow: hidden").text-center
                  v-col.my-2
                    v-skeleton-loader( v-for='i in 3' max-width="110px" max-height='110px' width='100%' height='110px' type="card").mx-auto.my-2
            v-divider
          v-container(v-else)
            noResults( :title="'No hay tiendas cerca de la ubicación'" :description="'En esta sección encontraras las tiendas'")
</template>

<script>
  /* eslint-disable */
  import axios from 'axios'
  import mapMarker from '@/assets/marker1.png'
  import imgShopDefault from '@/assets/icons/cart.png'
  import allCategorys from '@/assets/icons/products.png'
  import moment from 'moment'
  import * as vars from '@/vars.json'
  const geocoding = require('reverse-geocoding-google')
  export default {
    props: {
      place: '',
      categorie: Object,
    },
    components: {
      OrderModal: () => import('./components/OrderModal'),
      UserLocations: () => import('./components/UserLocations'),
      noResults: () => import('@/components/custom/NoResults.vue'),
    },
    filters: {
      numberFormat (val) {
        if (val) { return '$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    data () {
      return {
        allCategorys: allCategorys,
        dialogUserLocation: false,
        searchCategoryInShop: '',
        txtAddress: '',
        //map-card
        loading: false,
        selection: 1,
        // end - map-card
        filterDialog : false,
        shopSelected: null,
        dialogOrder: false,
        placeSearch: '',
        imgShopDefault: imgShopDefault,
        showAll: false,
        mainCategorieSelect: {},
        mainCategories: [],
        switch1: true,
        rangeShop: 5,
        timeout: null,
        zoom: 15,
        center: {lat: 10.963889, lng: -74.796387},
        category: '',
        markers: [],
        markersComplete: [],
        subCategory: '',
        subCategories: [],
        chip: 0,
        preset: 'today',
        currentPlace: null,
        option: {
          gestureHandling: "greedy",
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: true,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: true,
          styles: [
            {elementType: 'geometry', stylers: [{color: '#ebe3cd'}]},
            {elementType: 'labels.text.fill', stylers: [{color: '#523735'}]},
            {elementType: 'labels.text.stroke', stylers: [{color: '#f5f1e6'}]},
            {
              featureType: 'administrative',
              elementType: 'geometry.stroke',
              stylers: [{color: '#cbe7f4'}]
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'geometry.stroke',
              stylers: [{color: '#d4d9dc'}]
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [{color: '#a7aeaa'}]
            },
            {
              featureType: 'landscape.natural',
              elementType: 'geometry',
              stylers: [{color: '#a0c49a'}]
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [{color: '#dfd2ae'}]
            },
            {
              featureType: 'poi',
              elementType: 'labels.text.fill',
              stylers: [{color: '#93817c'}]
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry.fill',
              stylers: [{color: '#a5b076'}]
            },
            {
              featureType: 'poi.park',
              elementType: 'labels.text.fill',
              stylers: [{color: '#447530'}]
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [{color: '#f5f1e6'}]
            },
            {
              featureType: 'road.arterial',
              elementType: 'geometry',
              stylers: [{color: '#fdfcf8'}]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [{color: '#f8c967'}]
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [{color: '#e9bc62'}]
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry',
              stylers: [{color: '#e98d58'}]
            },
            {
              featureType: 'road.highway.controlled_access',
              elementType: 'geometry.stroke',
              stylers: [{color: '#db8555'}]
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [{color: '#806b63'}]
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [{color: '#dfd2ae'}]
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.fill',
              stylers: [{color: '#8f7d77'}]
            },
            {
              featureType: 'transit.line',
              elementType: 'labels.text.stroke',
              stylers: [{color: '#ebe3cd'}]
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [{color: '#dfd2ae'}]
            },
            {
              featureType: 'water',
              elementType: 'geometry.fill',
              stylers: [{color: '#b9d3c2'}]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [{color: '#92998d'}]
            }
          ],
        },
        autocompleteOptions: {
          componentRestrictions: {
            country: [
              'co',
            ],
          },
        },
        infoContent: {
          position: {
            lat: '4.6097224',
            lng: '-83.395109',
          },
          data: {
            location: ''
          }
        },
        infoWinOpen: false,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        searchTable: '',
        headers: [
          { text: 'Name', value: 'data.name'},
          { text: 'Address', value: 'data.addressgoogle' },
          { text: 'Categorie', value: 'data.mainCategorie.data' },
        ],
        headersInventory: [
          { text: 'Name', value: 'data.name'},
          { text: 'Price', value: 'data.price.sale' },
        ],
        searching: false,
        address: '',
        descriptionDialog: false,
        currentProduct: {
          location: [],
          data: {
            name: '',
            pictures: {},
          },
        },
        isInCart: false,
        actualShop: '',
      }
    },
    mounted () {
      if (this.categorie) {
        if (this.categorie.name) {
          this.categorie.name
          this.markers = this.markersComplete.filter(
            item => {
              return item.data.mainCategorie == this.categorie
            });
        }
      }
      // console.log(this.place)
      if (this.place) {
        this.placeSearch = this.place
        this.setPlaceSearch(this.place)
      }
      this.imgShopDefault = '@/assets/images/island.jpg'
      const vm = this
      if (!this.place) {
        vm.geolocate()
      }
      this.$store.dispatch('shops/getMainCategories', 'en').then(res => {
        if (res) {
          const categories = res.sort((a, b) => {
            if (a.data > b.data) {
              return 1
            }
            if (a.data < b.data) {
              return -1
            }
            return 0
          })
          this.mainCategories = categories
        }
      })
    },
    computed: {
      isMobile () {
        return  window.innerWidth < 1024
      },
      arrCart () {
        return this.$store.getters['pos/getCart']
      },
    },
    methods: {
      getTopProducts (store) {
        const vm = this
        store.data.loadingTopProds = true
        this.$forceUpdate()
        const info = {
          dates: {
            from: moment().subtract(29, 'days').format('YYYY-MM-DD'),
            to: moment().add(1, 'days').format('YYYY-MM-DD'),
          },
          userId: store.data.uid,
          shopId: store.data.id,
          context: '',
          getByCategory: vm.searchCategoryInShop,
        }
        vm.$store.dispatch('summary/top20Products', info).then(res => {
          store.data.loadingTopProds = false
          // console.log('prodstop20', res)
          if (res) {
            store.data.topSales = res
          } else {
            store.data.topSales = []
          }
          vm.$forceUpdate()
        })
      },
      seachByFilter () {
        const vm = this
        vm.filterDialog = false
        vm.search()
      },
      //map-card
      reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
      },
      //end - map-card
      selectShop (shopSelected) {

        if(this.isMobile && shopSelected.subdomain){
          this.$router.replace('/shop/' + shopSelected.subdomain)
        } else{
          this.shopSelected = shopSelected
          // console.log(this.shopSelected)
          this.dialogOrder = true
        }
       
      },
      changeScope () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.search(this.center.lat, this.center.lng)
        }, 1000, 'JavaScript')
      },
      keyUpSearchShopName () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
        }, 1000, 'JavaScript')
      },
      showAllMethod(){
        this.markers = this.markersComplete
      },
      searchSub (element) {
        const vm = this
        return element.category.find(categories => categories.name === vm.subCategory )
      },
      changeSubCategorie () {
        const vm = this
        vm.markers = []
        vm.markers.push(vm.markersComplete.find(vm.searchSub))
        this.showAll = false
      },
      setPlace (place) {
        const vm = this
        this.zoom = 16
        if (vm.switch1) {
          vm.center = {
            lat: +place.geometry.location.lat(),
            lng: +place.geometry.location.lng(),
          }
          vm.location = {
            lat: +place.geometry.location.lat(),
            lng: +place.geometry.location.lng(),
          }
          vm.location = vm.center
          vm.address = place.formatted_address
        }
        vm.search()
      },
      setPlaceSearch (place) {
        this.zoom = 16
        const vm = this
        vm.center = {
          lat: +place.geometry.location.lat(),
          lng: +place.geometry.location.lng(),
        }
        vm.currentPlace = place
        vm.search(place.geometry.location.lat(), place.geometry.location.lng())
      },
      getDirecction(latitude, longitude) {
        const config = {
          latitude: latitude,
          longitude: longitude,
          key: vars.googleKey,
        }
        geocoding.location(config, (err, data) => {
          if (err) {
            // console.log(err)
          } else {
            // console.log(data)
            this.txtAddress = data.results[0].formatted_address
          }
        })
      },
      geolocate () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          vm.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          vm.location = vm.center
          vm.search()
          this.getDirecction(position.coords.latitude, position.coords.longitude)
        })
      },
      setMarkers (results) {
        const vm = this
        vm.subCategories = []
        if(results.length > 0) {
          results.forEach(element => {
            element.category.forEach(categories => {
              vm.subCategories.push(categories.name)
            })
          });
        }
      },
      search () {
        const vm = this
        vm.searching = true
        const data = {
          location: vm.location,
          distance: vm.rangeShop,
          category: vm.mainCategorieSelect,
          name: vm.searchTable,
          categoryInShop: vm.searchCategoryInShop,
        }
        vm.$store.dispatch('shops/getVirtualShopData', data).then(async res => {
          // console.log(res.data)
          if (res.data) {
            vm.searching = false
            vm.markers = res.data
            vm.markers.forEach(marker => {
              vm.getTopProducts(marker)
            })
            vm.markersComplete = res.data
            vm.setMarkers(res.data)
          }
        })
      },
      clearAutomplete () {
        const vm = this
        vm.address = ''
        vm.location = ''
        vm.search()
      },
      clearFilter () {
        const vm = this
        vm.mainCategorieSelect = ''
        vm.searchTable = ''
        vm.search()
      },
      openInfoWindow (marker) {
        // console.log('aqui', marker)
        const vm = this
        vm.center = marker.position
        vm.zoom = 17
        vm.infoContent = marker
        vm.infoWinOpen = true
        // console.log(vm.infoContent)
      },
      addToCart (inventory, store) {
        const vm = this
        const data = inventory
        const inventoryShop = {
          id: store.data.id,
          uid: store.data.uid,
          name: store.data.name,
          pictures: store.data.img,
          inventory: {
            id: inventory.id,
            data,
          },
          context: 'order',
          addressInfo: {
            addressgoogle: store.data.addressgoogle,
            lat: store.data.location.lat,
            lng: store.data.location.lng,
          },
        }
        vm.$store.dispatch('pos/addToCart', inventoryShop).then(() => {
          // vm.getDataCart()
        })
      },
      getMarkerOptions (img) {
        if (img !== undefined && img !== '') {
          return {
            url: img.imageInput1,
            size: {width: 70, height: 70, f: 'px', b: 'px',},
            scaledSize: {width: 50, height: 50, f: 'px', b: 'px',},
          }
        } else {
          return {
            url: mapMarker,
            size: {width: 70, height: 70, f: 'px', b: 'px',},
            scaledSize: {width: 50, height: 50, f: 'px', b: 'px',},
          }
        }
      },
      showDescription (item, data) {
        const vm = this
        // console.log(item)
        vm.actualShop = data.id
        vm.currentProduct.data = item
        vm.currentProduct.id = item.id
        vm.descriptionDialog = true
        vm.isInCart = false
        for (let i = 0; i < vm.arrCart.length; i++) {
          const shop = vm.arrCart[i]
          for (let j = 0; j < shop.inventory.length; j++) {
            const product = shop.inventory[j]
            if (product.id === item.id) {
              vm.cartIndex = i
              vm.producIndex = j
              vm.cartId = shop.id
              vm.isInCart = true
            }
          }
        }
      },
      getStock (product) {
        if (product && product.location && product.location[this.actualShop.id]) {
          return product.location[this.actualShop.id].stock || 0
        }
        return 0
      },
    },
  }
</script>

<style scoped lang='scss'>
  .input-product{
    &:active,
    &:focus {
        outline: none;
    }
  }  
  
   .card-products{
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    flex-wrap: wrap;
    // min-height: 290px;
    max-height: 191px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 5px;
    position: relative;
    align-content: flex-start;
  }
  .divider {
    border-right: 2px solid #edeeee;
  }
  .store-list{
    background-color: #fff;
  }
  .store-card{
    max-height: 100px;
    min-width: 280px;
    width: 100%;
    max-width: 350px;
    margin: 10px;
    &__image{
      width: 120px;
      height: 80px;
      margin: auto 0;
      overflow: hidden;
      border-radius: 12px;
      img{
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    &__container{
      display: flex;
      justify-content: flex-start;
      align-self: center;
    }
  }

  .product-card{
    transition: .3s;
    display: flex;
    flex-direction:column;
    height: 100%;
    min-height: 160px;
    max-height: 160px;
    max-width: 125px;
    min-width: 125px;
    border-radius: 16px !important;
    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.3) !important;
    position: relative;
    overflow: hidden;
    &__tag {
      line-height: 15px;
      border-bottom: 1px dotted rgba(#000, 0.4);
      padding: 5px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 0;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before, &:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        background: #d2d3d5;
        bottom: -4px;
        border-radius: 50%;
        z-index: 1;

      }
      &:before {
        left: -4px;
      }
      &:after {
        right: -4px;
      }
    }
    &__container{
      padding-bottom: 35px;
      max-height: 75vh;
      overflow-y: auto;
      @media(min-width: 768px){
        height: 100%;
        overflow: auto;
      }
    }
    &__content{
      padding: 10px;
     //
    }
    &__background{
      max-height: 70px;
      width: 100px;
      margin: auto;
      overflow: hidden;
      border-radius: 12px;
     //
    }
    &__money-tag{
      font-size: 1em;
      font-weight: bold;
      &__sign{
        color: #01b9c0;
        margin-right: 5px;
      }
    }
    &__addBtn{
      display: flex;
      justify-content: flex-end;
      margin-top: auto;
      width: 30px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      &:hover{
        cursor:pointer;
        transform: scale(1.2);

      }

      &-container{
        width: 100px;
        height: 85px;
        margin-right: -35px;
        margin-bottom: -35px;
        background: #00b9c0;
        color: #ffF;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 800;
        padding-left: 13px;
        display: flex;
        flex-direction: column;
        span{
          font-size: 35px;
          margin-top: 5px;
          margin-left: 0px;
        }
      }
    }
  }  
  .loading-bar {
    position: absolute;
    z-index: 999;
  }
  .filter-container{
    position: absolute;
    z-index: 999;
    width: 30%;
  }
  .marketplace{
    &__map{
      @media (max-width: 600px) {
        position: relative;
        max-height: calc(100vh - 200px);
        overflow-y: auto;
        width: 100%;
        padding: 5px;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
      }
    }
  }
  .marketplace-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start ;
    align-items: flex-start;
    overflow-y: hidden;
    margin: 0 !important;
    @media (min-width: 600px) {
      max-height: calc(100vh - 70px);
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start ;
    }
  }
  .store-row{
    width: 100%;
    &__header{
      .v-list-item-title{
        font-weight: 800;
      }
    }
    &__list{
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto;
      padding: 10px;
      &__item{
        min-width: 140px;
        margin: 0;
        @media (min-width: 600px) {
          min-width: 240px;
        }
        img{
          height: 120px;
          width: 100px;
          object-fit: cover;
        }
      }
    }
  }
  .store-card{
    background-color: transparent;
    flex-direction: column;
    display: flex;
    justify-content: space-around;
    align-items: center;
    max-width: 125px;
    height: 220px;
    @media (min-width: 600px) {
      max-width: 240px;
    }
    &__image{
      height: 100px;
      min-height: 100px;
      max-height: 100px;
      width: 120px;
      border-radius: 20px !important;
      overflow: hidden;
      /*border-radius: 15px;*/
    }
    &__info{
      text-align: left;
      display: flex;
      flex-direction: column;
      min-height: 60px;
      justify-content: space-between;
    }
    &__title{
      text-align: left;
    }
    &__subtitle{
      text-align: left;
    }
    &__cta{
      width: 80px;
      margin-top: 10px;
    }
  }
  .btn-card {
    right: -400%;
    top: -20px;
  }
  .btn-call {
    left: 80%;
    top: -20px;
  }
  .map-card {
    max-width: 100%;
    max-height: 100%;
    display: block;
    width: 100%;
    @media (max-width: 600px) {
      max-height: 340px;
    }
    &__image{
      max-height: 150px;
    }
    &__content{
      font-size: 12px;
    }
  }
  #map{
    height: 600px;
  }
  .location-input{
    width: 100%;
    border-bottom: 1px solid #d2d2d2;
  }
  .search-filter{
    max-width: 450px;
    max-height: calc(100vh - 70px);
    overflow-y: auto;
    &__search{
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin:0 !important;
      &__item{
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
      }
    }
  }
  @media (max-width: 425px) {
    .search-filter{
      max-height: 130px;
      .v-slider__track-background.primary.lighten-3
      .v-application .primary.lighten-3{
        background-color: #eee !important;
      }
      background-color: rgba(#fff, 0.65) !important;
      position: relative;

      top: 0px;
      left: 0;
      width: 100%;
      z-index: 0;
      box-shadow: 0;
      outline: 0;
      border: 0;
      height: 25%;
      display: flex;
      align-items: center;
      &__search{
        display: flex;
      // font-size: 20pt;
        justify-content: space-around;
      }
      &__date-filter,
      &__category{
        display: none;
      }
      .autocomplete-block{
        padding: 0 1rem;
      // background-color: #bada55;
        display: flex;
        background:#f3f2f3;
        grid-template-columns: 40px max-content;
        align-items: center;
        border-radius: 5px;
        img{
          width: 100%;
        }
        .location-input{
          height: 100%;
          border: none;
          padding: 0 1rem;
          &:focus{
            outline: none !important;
          }
        }
      }
    }
    .filter-block{
      position: relative;
      background-color: #e9e7e7 !important;
      &__content{
        width: 90%;
        margin: 2rem auto 0;
        background-color: #fff;
        border-radius: 17px !important;
        padding: 2rem 1rem;
      }
      .filter-block__header-wrapper{
        position: relative;
        width: 100%;
        &::after{
          content: "";
          width: 100%;
          height: 2px;
          background-color: rgba(#000, 0.5);
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          z-index: 0;
        }
      }
      .filter-block__header{
        color: var(--secondary-color) !important;
        width: max-content;
        margin: 0 auto;
        padding: 0 1rem;
        background-color: #fff;
        position: relative;
        z-index: 100;
      }
      .v-slide-group__content{
        display: flex;
        justify-content: center;
        align-items: center;
        span,
        p,a{
          font-size: 13pt;
        }
      }
    }
  }
  .search {
    min-height: 500px;
    background: #fcf8f8;

    &__shops {
      display:flex; 
      flex-direction: row; 
      flex-wrap: nowrap; 
      overflow-x: auto;
    }

    &__shop {
      display: flex; 
      flex-direction: column;
      justify-content:center;
      align-items:center;
      margin: 0 .5rem;
      min-width: 70px;
      text-align: center;
    }

    &__rounded-img {
      object-fit: cover;
    }

    &__avatar {
      box-shadow: 0 1rem 2rem rgba(#000, .2);
      border: #fff solid 4px;
    }

    &__location {
      font-weight: 900;
      max-width: 60%;
      color: #000;
    }

    &__shop-title {
      font-weight: 800;
      font-size: 1.2rem;
      margin-left: 1rem;
    }

    &__topsale {
      margin: 1rem auto;
      flex-flow: nowrap;
      overflow-x: auto;
    }

    &__topsales-item {

      &-img {
        width: 8rem;
        height: 8rem;
        object-fit: cover;
      }

      &-title {
        font-weight: 300;
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      &-price {
        font-weight: 800;
        display: block;
      }
    }
  }
</style>